import { green } from "@material-ui/core/colors";
const TableStyle = (theme) => ({
  container: {
    minHeight: "calc(80vh - 350px)",
    maxHeight: "calc(80vh - 350px)",
    width: "1000px",
  },
  fs12: {
    fontSize: "10px",
  },
  fs10: {
    fontSize: "10px",
  },
  // fs12: {
  //   fontSize: "14px",
  // },
  BgDeleteIcon: {
    width: "36px",
    height: "30px",
    backgroundColor: "#e6e6e6",
    borderRadius: "8px",
  },
  DeleteIcon: {
    width: "20px",
    height: "20px",
    marginLeft: "0px",
    marginTop: "5px",
    cursor: "pointer",
  },
  block: {
    minHeight: "calc(100vh - 310px)",
    maxHeight: "calc(100vh - 310px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  imageWidth: {
    width: "80px",
  },
  imageText: {
    fontSize: "12px",
    textAlign: "center",
    margin: "0 0 10px",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  w20p: {
    width: "20px",
  },
  
  tripendbutton: {
    fontSize: "11px",
    height: "40px",
    width: "20px",
    textTransform: "capitalize",
  },
  tripsheetbutton: {
    fontSize: "12px",
    height: "50px",
    width: "120px",
    textAlign: "center",
    textTransform: "capitalize",
  },
  ntmcostWidth: {
    height: "40px",
    width: "60px",
  },
  eWayContainer: {
    minHeight: "calc(100vh - 235px)",
    maxHeight: "calc(100vh - 235px)",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  costingContainer: {
    height: "100%",
    width: "100%",

    // minHeight: "calc(115vh - 300px)",
    // maxHeight: "calc(115vh - 300px)",
    //maxWidth:"2200px"
    // padding:"4px 4px 4px 4px",
  },
  costingContainer1: {
    height: "100%",
    width: "100%",

    // minHeight: "calc(115vh - 300px)",
    // maxHeight: "calc(115vh - 300px)",
    //maxWidth:"2200px"
    // padding:"4px 4px 4px 4px",
  },
  costingContainer2: {
    minHeight: "calc(115vh - 300px)",
    maxHeight: "calc(115vh - 300px)",
    maxWidth: "2200px",

    // minHeight: "calc(115vh - 300px)",
    // maxHeight: "calc(115vh - 300px)",
    //maxWidth:"2200px"
    // padding:"4px 4px 4px 4px",
  },
  PTLContainer: {
    minHeight: "calc(120vh - 270px)",
    maxHeight: "calc(120vh - 270px)",
  },
  TripConfirmationContainer: {
    minHeight: "calc(100vh - 285px)",
    maxHeight: "calc(100vh - 285px)",
  },
  StartCircle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
  },
  EndCircle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
  },
  dn: {
    display: "none !important",
  },
  AddTripContainer: {
    minHeight: "calc(100vh - 445px)",
    maxHeight: "calc(100vh - 445px)",
  },
  ml220p: {
    marginLeft: "220px",
  },
  underline: {
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
  bgInput: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "8px",
  },
  loader: {
    textAlign: "center",
  },
  bgInput1: {
    marginBottom: "15px",
  },
  inputNumber: {
    width: "65px",
    height: "20px",
    marginLeft: "0px",
    marginTop: "5px",
  },
  sealNumber: {
    width: "85px",
    height: "20px",
    marginLeft: "0px",
    marginTop: "5px",
  },
  bgInputGray: {
    backgroundColor: "#e6e6e6",
    borderRadius: "8px",
    height: "30px",
    paddingLeft: "8px",
  },
  inputSelect: {
    width: "100px",
    height: "30px",
    borderRadius: "8px",
    borderColor: "#e6e6e6",
  },
  w200p: {
    width: "160px",
    height: "25px",
  },
  tempViewTripcontainer: {
    minHeight: "calc(100vh - 410px)",
    maxHeight: "calc(100vh - 410px)",
  },
  textColor: {
  },
  storeTableDialog: {
    minWidth: 800,
    maxWidth: 800,
  },
  vehicleMasterDialog: {
    minWidth: 850,
    maxWidth: 850,
    minHeight: 400,
    maxHeight: 400,
  },
  vehicleMasterDialog1: {
    minWidth: 850,
    maxWidth: 850,
    minHeight: 220,
    maxHeight: 220,
  },
  contractMasterDialog: {
    minWidth: 800,
    maxWidth: 800,
    minHeight: 500,
    maxHeight: 500,
  },
  LocationMasterDialog: {
    minWidth: 400,
    maxWidth: 400,
    minHeight: 300,
    maxHeight: 300,
  },
  OriginDestinationDialog: {
    minWidth: 850,
    maxWidth: 850,
    minHeight: 400,
    maxHeight: 400,
  },
  OriginDestinationDialog2: {
    minWidth: 900,
    maxWidth: 900,
    minHeight: 500,
    maxHeight: 500,
  },
  OriginDestinationDialog1: {
    minWidth: 800,
    maxWidth: 800,
    minHeight: 700,
    maxHeight: 700,
  },
  BOLTableDialog: {
    minWidth: 800,
    maxWidth: 800,
  },
  TripSheetDialog: {
    minWidth: 400,
    maxWidth: 400,
    minHeight: 450,
    maxHeight: 450,
  },
  searchBarStyle: {
    position: "sticky",
    borderTop: "0px",
    borderLeft: "0px",
    borderRadius: "7px",
    backgroundColor: "#e6e6e6",
    borderColor: "#e6e6e6",
    paddingTop: "3px",
    paddingLeft: "3px",
  },
  icon: {
    fontSize: "1.0rem",
  },
  commentDialog: {
    minWidth: 300,
    maxWidth: 300,
    maxHeight: 150,
    minHeight: 150,
  },
  commentStyle: {
    width: "300px",
    height: "30px",
    borderRadius: "8px",
    backgroundColor: "#e6e6e6",
    borderColor: "#e6e6e6",
  },
  SelectStyle: {
    width: "250px",
    height: "36px",
    paddingLeft: "2px",
    fontSize: "12px",
    borderRadius: "8px",
    backgroundColor: "#e6e6e6",
    borderColor: "#e6e6e6",
  },
  pdT20: {
    paddingTop: "20px",
  },
  dailyContainer: {
    minHeight: "calc(100vh - 235px)",
    maxHeight: "calc(100vh - 235px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "space-between",
  },
  formControl: {
    margin: theme.spacing(1),
    width: 30,
  },
  indeterminateColor: {
  },
  selectAllText: {
    fontSize: "12px",
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  inputDailySelect: {
    width: "170px",
    height: "25px",
    borderRadius: "8px",
    borderColor: "#e6e6e6",
  },
  align: {
    alignItems: "baseline",
  },
  pl48: {
    paddingLeft: "48rem",
  },
  ml5: {
    marginLeft: "4px",
  },
  mt3: {
    marginTop: "7px",
  },
  input: {
    display: "none",
  },
  StoreTableDialog: {
    minWidth: 600,
    maxWidth: 600,
  },
  inputmargin: {
    marginRight: "20px",
    fontSize: "12px",
    height: "25px",
    textAlign: "center",
    // backgroundColor:"#EEF2FF",
    width: "170px",
  },
  inputmargin3: {
    marginLeft: "20px",
    marginRight: "20px",
    fontSize: "12px",
    height: "25px",
    textAlign: "center",
    // backgroundColor:"#EEF2FF",
    width: "170px",
  },
  inputmarginorigindest: {
    marginRight: "2rem",
    fontSize: "12px",
    height: "30px",
    textAlign: "center",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  marginLeftSearch: {
    marginLeft: "20rem",
  },
  marginLeftSearch1: {
    marginLeft: "40rem",
    marginBottom: "1rem",
  },
  marginLeftEmployee: {
    marginTop: "1rem",
    marginLeft: "10px",
  },
  moreColor: {
    color: "#f74e10",
  },
  successColor: {
    backgroundColor: ["#4caf50", "#66bb6a", "#43a047", "#5cb860"],
  },
  SelectStyleTripCreation: {
    width: "200px",
    height: "36px",
    paddingLeft: "2px",
    fontSize: "12px",
    borderRadius: "8px",
    backgroundColor: "#e6e6e6",
    // borderColor: "#3FAABF",
  },
  inputmargin1: {
    // marginRight:"20px",

    // fontSize:"12px",

    // height:"30px",

    // textAlign:"center",

    // width:"170px"

    display: "flex",

    flexDirection: "column",

    width: "170px",
  },
  inputmarginskills: {
    display: "flex",

    flexDirection: "column",

    width: "60%",
  },

  inputmargin2: {
    marginLeft: "15px",

    // fontSize:"12px",

    // height:"30px",

    // textAlign:"center",

    // width:"170px"

    display: "flex",

    flexDirection: "column",

    width: "170px",
  },
});

export default TableStyle;
